import React from 'react';
import Box from '@material-ui/core/Box';
import UserDialog from './UserDialog';
import NerdleStats from './NerdleStats';

var GoogleAuth;
var SCOPE = 'https://www.googleapis.com/auth/youtube.readonly';

class NerdleMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthorized: false,
      user: null,
      height: 0,
      width: 0,
      map: null,
      markers: [],
      nerds: [],
      aggregate: {}
    };
    this.initClient = this.initClient.bind(this);
    this.handleAuthClick = this.handleAuthClick.bind(this);
    this.updateSigninStatus = this.updateSigninStatus.bind(this);
    this.getChannelData = this.getChannelData.bind(this);
    window.gapi.load('client:auth2', this.initClient);
  }

  initClient() {
    var nm = this;
    // Retrieve the discovery document for version 3 of YouTube Data API.
    // In practice, your app can retrieve one or more discovery documents.
    var discoveryUrl = 'https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest';

    // Initialize the gapi.client object, which app uses to make API requests.
    // Get API key and client ID from API Console.
    // 'scope' field specifies space-delimited list of access scopes.
    window.gapi.client.init({
      'apiKey': 'AIzaSyChjqaYNgg7wyo1JykrtX2ae9yZReUvpVE',
      'discoveryDocs': [discoveryUrl],
      'clientId': '274449434503-np0652b5hqfc3ulqohqahvthd2tpnstv.apps.googleusercontent.com',
      'scope': SCOPE
    }).then(function () {
      GoogleAuth = window.gapi.auth2.getAuthInstance();

      // Listen for sign-in state changes.
      GoogleAuth.isSignedIn.listen(nm.updateSigninStatus);

      nm.updateSigninStatus();
    },
      function (e) { console.log(e) });
  }

  componentDidMount() {
    this.getMarkers();
    var map;
    map = new window.google.maps.Map(document.getElementById('map'), {
      center: { lat: 25.9875078, lng: -97.1859741 },
      zoom: 3,
      zoomControl: true,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_BOTTOM
      },
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false
    });
    this.setState({ map: map });
  }

  getMarkers = () => {
    var ctx = this;
    window.jQuery.ajax({
      url: 'https://uc4pf5uyvffabpzg4zpephfet40ocvsi.lambda-url.us-east-1.on.aws/',
      success: function (data) {
        var userList = data;
        ctx.updateMarkers(userList);
      },
      error: function (error) {
        alert("Please tell mouser58907 you got the following error: " + JSON.stringify(error));
        ctx.setState({
          open: true,
          loading: false
        });
      }
    });
  }

  latlonAggregate = (data) => {
    var dict = {};
    data.forEach((entry) => {
      var key = this.latlonString(entry.lat, entry.long);
      if (key in dict) dict[key].push(entry);
      else dict[key] = [entry];
    });
    return dict;
  }

  latlonString = (lat, long) => {
    return lat + "," + long;
  }

  updateMarkers = (data, filter) => {
    this.clearMarkers();
    var markers = [];
    var aggregate = this.latlonAggregate(data);
    var infoWindow = new window.google.maps.InfoWindow({
      content: "contentString"
    });
    for (var key in aggregate) {
      // Filter for search results
      var includeInResults = false;
      for(var i = 0; i < aggregate[key].length; i++) {
        includeInResults = includeInResults || (filter == null) || aggregate[key][i].title.toLowerCase().includes(filter.toLowerCase());
      }
      if (!includeInResults) continue;

      var nerd = aggregate[key][0];
      var marker = new window.google.maps.Marker({
        position: { lat: nerd.lat, lng: nerd.long },
        map: this.state.map,
        title: nerd.location,
        popupHtml: this.infoBoxContent(aggregate[key])
      });
      var ctx = this;
      marker.addListener('click', function () {
        infoWindow.setContent(this.popupHtml);
        infoWindow.open(ctx.state.map, this);
      });

      markers.push(marker);
    };
    this.setState({ markers: markers, aggregate: aggregate, nerds: data });
  }

  infoBoxContent = (userList) => {
    var html = "<h4>" + userList[0].location + "</h4>";
    userList.forEach((user) => {
      html += '<div class="user">'
      html += '<img src="' + user.imageUrl + '" class="avatar"/>';
      html += '<span class="ytname">' + user.title +'</span>';
      html += '</div>'
    })
    return html;
  }

  clearMarkers = () => {
    var markers = this.state.markers;
    markers.forEach((nerd) => nerd.setMap(null));
  }
  
  searchChange = (event) => {
    this.updateMarkers(this.state.nerds, event.target.value)
  }

  updateSigninStatus() {
    var user = GoogleAuth.currentUser.get();
    var isAuthorized = user.hasGrantedScopes(SCOPE);
    this.setState({ isAuthorized: isAuthorized})
    if (this.state.isAuthorized) {
      this.setState({ tokens: user.getAuthResponse() })
      this.getChannelData();
    } else {
      this.setState({ user: null });
    }
  }

  handleAuthClick() {
    if (this.state.isAuthorized) {
      // User is authorized and has clicked 'Sign out' button.
      GoogleAuth.signOut();
    } else {
      // User is not signed in. Start Google auth flow.
      GoogleAuth.signIn();
    }
  }

  revokeAccess() {
    GoogleAuth.disconnect();
  }

  getChannelData() {
    var instance = this;
    return window.gapi.client.youtube.channels.list({
      "part": "snippet",
      "mine": true
    })
      .then(function (response) {
        // Handle the results here (response.result has the parsed body).
        var body = JSON.parse(response.body);
        var snippet = body.items[0].snippet;
        var user = {
          image: snippet.thumbnails.default.url,
          name: snippet.title,
          tokens: instance.state.tokens
        }
        instance.setState({ user: user });
      },
        function (err) { console.error("Execute error", err); });
  }

  render() {
    const styles = {
      width: "100%",
      height: "100%"
    }
    return (
      <>
        <Box style={styles} id="mapContainer" color="text.primary">
          <div style={styles} id="map"></div>
          <UserDialog user={this.state.user} authHandler={this.handleAuthClick} isAuthorized={this.state.isAuthorized} revokeHandler = {this.revokeAccess}/>
          <NerdleStats data={this.state.nerds} onSearchChange={this.searchChange}/>
          
        </Box>
      </>
    );
  }
}
export default NerdleMap;










